module.exports = __webpack_public_path__ + "img/fall.4b8da1bf.svg";